import type { DocOrderReconRow } from '@/services/bankerReconService';
import type { LoanRevenue } from './types';

/** Replace the draft's managed Doc Order rows with the authoritative feed. */
export function replaceDocOrderReconRows(
  current: LoanRevenue[],
  managedLineTypes: ReadonlySet<string>,
  rows: DocOrderReconRow[]
): LoanRevenue[] {
  const managed = new Set([
    ...managedLineTypes,
    ...rows.map(row => row.lineType)
  ]);
  return [
    ...current.filter(row => !managed.has(row.id)),
    ...rows.map(row => ({
      id: row.lineType,
      description: row.description,
      amount: row.amount,
      reimbursable: row.reimbursable,
      ...(row.fee_source ? { fee_source: row.fee_source, nets_to_warehouse_advance: row.nets_to_warehouse_advance } : {})
    }))
  ];
}
